export enum USER_STATUS {
  ACTIVATED = 'AC',
  DEACTIVATE = 'DA',
  DELETED = 'DL',
}

export enum USER_CHIP_COLORS {
  ACTIVATED = '#1E9048',
  DEACTIVATED = '#8A8A8A',
  DELETED = '#B43236',
}
